// Layout.js

import React from 'react';
import { Helmet } from 'react-helmet';

const Layout = ({ children }) => {
    // console.log('Layout component rendered');
  return (
    <>
      <Helmet>
      <meta name="google-site-verification" content="pRgooO9ANd9-S-HhZbcbquPoDeyGjqJzo6CRHlo9Nvk" />
     
      </Helmet>
      {children}
    </>
  );
};

export default Layout;
